<div class="full-width">
    <div class="lang">
        <button mat-icon-button [matMenuTriggerFor]="langMenu">
            <mat-icon>g_translate</mat-icon>
        </button>
        <mat-menu #langMenu="matMenu" class="menu">
            <button mat-menu-item (click)="changeLang('en')" [ngClass]="currentLang === 'en' ? 'active' : ''">English</button>
            <button mat-menu-item (click)="changeLang('es')" [ngClass]="currentLang === 'es' ? 'active' : ''">Spanish</button>
        </mat-menu>
    </div>
    <div class="login">
        <router-outlet></router-outlet>
    </div>
    <div class="info">
        <!-- <h1>Welcome to Cortizo App Dashboard</h1>
        <p>
            E-commerceApp helps you to build organized and create beautiful and rich mobile application.
            Join us and start building your application today
        </p>
        <span>More than 17k people joined us, it's your turn!</span> -->
    </div>
</div>